// extracted by mini-css-extract-plugin
export var discard = "_1x-4";
export var muiTooltipTooltip = "_1x-6";
export var notificationBar = "_1x-3";
export var notificationContainer = "_1x-2";
export var saveButtonHoverSlotWrapper = "_1x-5";
export var show = "_1x-1";
export var spacer = "_1x-0";